<template>
    <div>
        <my-header></my-header>
        <div class="about">
            <div class="content">
                <h1>关于我们</h1>
                <p v-html="$store.state.config.about"></p>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    head: {
        title: '关于我们·电子保函查验平台'
    },
    data: () => ({
        
    }),
    methods: {
        
    },
    created() {
        
    },
    mounted() {
        
    }
}
</script>

<style lang="scss" scoped>
    .header{
        background-image: url(~@images/guarantee/banner2.jpg);
        background-repeat: no-repeat;
        background-position:0 -56px;
        background-size:cover;
    }
    .products {
        text-align: center;
        img{
            width: 1190px;
            box-shadow: 0px 0px 9px 1px rgba(0, 0, 0, 0.1);
        }
    }
    .about{
            font-family: Microsoft YaHei;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #333333;
            .content{
                min-height:600px;
                h1{
                    width: 1048px;
                    text-align: center;
                    margin:0 auto;
                    padding:36px 0;
                    margin-bottom:28px;
                    font-size: 34px;
                    border-bottom: 1px solid#ced3db;
                }
                p{
                    width: 100%;
                    height: 410px;
                    margin:0 auto;
                    font-size: 16px;
                    line-height: 32px;
                    color: #333333;
                    text-indent:2em;
                }
            }

    }
</style>
